module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "id": _vm.formId,
      "method": _vm.method,
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "name": "token",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "file",
      "id": _vm.pickerId,
      "type": "file",
      "accept": _vm.accept,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "accept",
      "type": "hidden"
    }
  }), _vm._v(" "), _vm._t("form")], 2), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.pickerId
    }
  }, [_vm._t("picker", [_c('em', [_vm._v("upload")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-46dd337e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/upload.vue
// module id = 6
// module chunks = 0